export const INDEX = "/";
export const ABOUT = `${INDEX}about-me`;
export const CONTACT = `${INDEX}contact`;
export const PRIVACY_POLICY = `${INDEX}privacy-policy`;
export const EXPERIENCE = `${INDEX}experience`;
